import React, { useState, useEffect } from 'react';
import { Outlet, Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../App';
import { MessageSquare } from 'lucide-react';

export default function PublicLayout() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/public/settings`, { cancelToken: source.token });
        setSettings(res.data);
      } catch (err) {
        if (!axios.isCancel(err)) console.error(err);
      }
    };
    fetchSettings();
    return () => source.cancel();
  }, []);

  const outletContextValue = React.useMemo(() => ({ settings }), [settings]);

  return (
    <div className="min-h-screen bg-[#FDF9F1] text-slate-900 font-sans selection:bg-orange-200 relative">
      <header className="sticky top-0 z-50 bg-[#FDF9F1]/95 backdrop-blur-md border-b border-slate-300">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-24 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            {settings.logo_url ? (
              <img src={`${settings.logo_url.startsWith('http') ? '' : API_URL}${settings.logo_url}`} alt="Logo" className="h-16 w-auto object-contain" />
            ) : (
              <span className="text-2xl font-bold font-serif text-slate-900 tracking-widest uppercase">{settings.title || "Island Flavors"}</span>
            )}
          </Link>
          <nav className="flex items-center space-x-8">
            <Link to="/menu" className="font-sans font-bold text-slate-800 tracking-widest uppercase text-sm hover:text-orange-600 transition-colors">Menús</Link>
            <a href={`sms:${settings.contact_phone}?body=${encodeURIComponent('Hello, I found your website and would like to get more information about your catering services.')}`} className="hidden sm:inline-flex rounded-sm border-2 border-slate-900 text-slate-900 font-bold uppercase tracking-widest text-xs px-6 py-3 hover:bg-slate-900 hover:text-[#FDF9F1] transition-colors">
              Contáctanos
            </a>
          </nav>
        </div>
      </header>
      
      <main>
        <Outlet context={outletContextValue} />
      </main>

      <footer className="bg-slate-900 text-[#FDF9F1] py-16 border-t-[6px] border-orange-600">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h3 className="text-3xl font-serif mb-6 tracking-[0.2em] uppercase">{settings.title || "Island Flavors"}</h3>
          <p className="font-sans tracking-widest text-sm text-slate-400 mb-2">{settings.contact_phone} | {settings.contact_email}</p>
          <p className="font-sans text-xs text-slate-500 mt-8 uppercase tracking-widest">© {new Date().getFullYear()} {settings.title}. Todos los derechos reservados.</p>
        </div>
      </footer>

      {settings.contact_phone && (
        <a
          href={`sms:${settings.contact_phone}?body=${encodeURIComponent('Hello, I found your website and would like to get more information about your catering services.')}`}
          className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 bg-orange-600 text-white p-4 rounded-full shadow-2xl hover:bg-orange-700 hover:scale-110 transition-all duration-300 z-50 flex items-center justify-center group"
          aria-label="Enviar SMS"
          title="Enviar SMS"
        >
          <MessageSquare className="h-7 w-7" />
          <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs transition-all duration-300 ease-in-out font-sans font-bold text-sm tracking-widest uppercase pl-0 group-hover:pl-3 opacity-0 group-hover:opacity-100">
            SMS
          </span>
        </a>
      )}
    </div>
  );
}
